import { Component, Input } from '@angular/core';
import { Activity } from '../../core/dto/activity.dtos';
import { LanguageService } from '../../core/services/language.service';
import { bokunImg, bokunSrcset } from 'src/app/shared/utils/bokun-image';

@Component({
    standalone: false,
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent {
    @Input() data!: Activity;
    @Input() isPopular: boolean = false;
    readonly fallbackImage = 'assets/imgs/blog-cards/blog_new/default.webp';
    
    constructor(private langService: LanguageService) {}

    get productLink(): any[] {
        if (!this.data?.id || !this.data?.title) {
            return ['/home', this.langService.lang];
        }
        return this.langService.buildProductRoute(this.data.id, this.data.title);
    }

    get imageUrl(): string {
        const candidate = this.data?.keyPhoto?.originalUrl;
        return candidate && candidate.trim() ? bokunImg(candidate, 800) : this.fallbackImage;
    }

    get imageSrcset(): string | null {
        return bokunSrcset(this.data?.keyPhoto?.originalUrl);
    }

    get imageAlt(): string {
        const alt = this.data?.keyPhoto?.alternateText;
        if (alt && alt.trim()) return alt;
        return this.data?.title || 'Tour image';
    }
}
